import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { validateCandidateToken } from '@/lib/candidateToken';

/**
 * /c/:token — Valida token y redirige a consent o instructions según estado.
 */
export function CandidateEntryPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate('/c/error/invalid', { replace: true });
      return;
    }
    validateCandidateToken(token)
      .then((v) => {
        if (!v.valid) {
          const to = v.reason === 'completed' ? '/c/error/completed' : '/c/error/invalid';
          navigate(to, { replace: true, state: { reason: v.reason } });
          return;
        }
        navigate(`/c/${token}/consent`, { replace: true });
      })
      .catch((err) => {
        if (import.meta.env?.DEV) console.warn('[PsyTalent] Error validando enlace:', err);
        navigate('/c/error/invalid', { replace: true, state: { reason: 'invalid', error: String(err?.message ?? err) } });
      });
  }, [token, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-muted-foreground">Verificando enlace...</p>
    </div>
  );
}
